// extracted by mini-css-extract-plugin
export default {"card":"SuccessCard_card__hm8KA","iconLeft":"SuccessCard_iconLeft__cC1Fr","iconRight":"SuccessCard_iconRight__vy-Sj"};